import Vue from "vue";
import Router from "vue-router";
import AuthLogin from "@/views/AuthLogin.vue";
import DashboardApp from "@/views/DashboardApp.vue";
import EmployeeApp from "@/views/EmployeeApp.vue";
import ParameterApp from "@/views/ParameterApp.vue";
import RealizationApp from "@/views/RealizationApp.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import ProfileApp from "@/views/ProfileApp.vue";
import RequestResetPassword from "@/views/RequestResetPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import WorkflowSteps from "@/views/WorkflowSteps.vue";
import ApprovalApp from "@/views/ApprovalApp.vue";
import ValidationApp from "@/views/ValidationApp.vue";
import ReportBudget from "@/views/ReportBudget.vue";
import ItemApp from "@/views/ItemApp.vue";
import SupplierApp from "@/views/SupplierApp.vue";
import WbApp from "@/views/WbApp.vue";
import UomApp from "@/views/UomApp.vue";
import TypeAssetApp from "@/views/TypeAssetApp.vue";
// import SpecificationApp from "@/views/SpecificationApp.vue";
import MaterialApp from "@/views/MaterialApp.vue";
import CategoryApp from "@/views/CategoryApp.vue";
import CoaApp from "@/views/CoaApp.vue";
import BrandApp from "@/views/BrandApp.vue";
import BudgetApp from "@/views/BudgetApp.vue";
import PFApp from "@/views/PFApp.vue";
import GenerateApp from "@/views/GenerateApp.vue";
import NotFound from "@/components/NotFound.vue";
import store from "@/store"; // Import Vuex store

Vue.use(Router);

const router = new Router({
  mode: "history", // Gunakan mode history untuk menghilangkan hash (#) di URL
  routes: [
    {
      path: "/generate",
      component: GenerateApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/budget",
      component: BudgetApp,
      name: "budget",

      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/purchase-frequency",
      component: PFApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/item",
      component: ItemApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/brand",
      component: BrandApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/coa",
      component: CoaApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/item-category",
      component: CategoryApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/material",
      component: MaterialApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    // {
    //   path: "/specification-desc",
    //   component: SpecificationApp,
    //   meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    // },
    {
      path: "/type-of-asset",
      component: TypeAssetApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/uom",
      component: UomApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/worksheet-budget",
      component: WbApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/supplier",
      component: SupplierApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/item",
      component: ItemApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/",
      component: BudgetApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/login",
      name: "login",
      component: AuthLogin,
      beforeEnter: (to, from, next) => {
        const tokenJwt = to.query.token_jwt; // Ambil token dari query parameter

        if (tokenJwt) {
          store.dispatch("user/saveJwtToken", tokenJwt);
          window.history.replaceState(null, "", to.path);
          return next({ name: "budget" });
        }

        if (store.getters["user/getJwtToken"]) {
          return next({ name: "budget" });
        }

        // Jika tidak ada token, tetap di halaman login
        next();
      },
    },
    {
      path: "/request-reset-password",
      name: "request-reset-password",
      component: RequestResetPassword,
    },
    {
      path: "/reset-password/:token",
      name: "reset-password",
      component: ResetPassword,
      props: true, // token_jwt akan diteruskan ke komponen sebagai prop
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    {
      path: "/realization",
      name: "Realization",
      component: RealizationApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfileApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    {
      path: "/employees",
      name: "employee",
      component: EmployeeApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/workflow-steps",
      name: "workflow-steps",
      component: WorkflowSteps,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/parameters",
      name: "parameter",
      component: ParameterApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },
    {
      path: "/approvals",
      name: "approvals",
      component: ApprovalApp,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    {
      path: "/point/validation/:id/:token",
      name: "validation",
      component: ValidationApp,
    },
    {
      path: "/report-budget",
      name: "reportBudget",
      component: ReportBudget,
      meta: { requiresAuth: true }, // Menandai bahwa route ini membutuhkan autentikasi
    },

    { path: "*", component: NotFound, meta: { requiresAuth: true } }, // Route not found
  ],
});

// Navigation guard untuk memeriksa autentikasi
router.beforeEach((to, from, next) => {
  // Jika route membutuhkan autentikasi
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log(this.$route.query.token_jwt);

    const token_jwt = store.getters["user/getJwtToken"];
    if (!token_jwt) {
      // Jika token_jwt tidak ada, arahkan ke halaman login
      next({ name: "login" });
      // next();
    } else {
      // Jika token_jwt ada, lanjutkan ke route tujuan
      next();
    }
  } else {
    // Jika route tidak membutuhkan autentikasi, lanjutkan ke route tujuan
    next();
  }
});

export default router;
